import React from 'react'
import { Select, Stack, TextInput, Title } from '@mantine/core'
import { STATES } from '../../../utils/constants'
import { OnboardingLocation } from '../../../models/Onboarding/OnboardingLocation'

interface ManualAddressFormProps {
  location: OnboardingLocation
  updateAddress: (location: Partial<OnboardingLocation>) => void
}

const ManualAddressForm: React.FC<ManualAddressFormProps> = ({
  location,
  updateAddress,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    // Allow only digits and hyphen for zipCode input
    if (name === 'zipCode' && !/^\d*-?\d*$/.test(value)) {
      return
    }

    updateAddress({
      [name]: value || '',
    })
  }

  const handleSelectChange = (name: string, value: string | null) => {
    updateAddress({
      [name]: value || '',
    })
  }

  return (
    <Stack w='100%' maw={700}>
      <Title>Enter your location's address</Title>
      <TextInput
        label='Street'
        placeholder='123 Main St'
        name='address'
        value={location.address || ''}
        onChange={handleInputChange}
      />
      <TextInput
        label='City'
        placeholder='Knoxville'
        name='city'
        value={location.city || ''}
        onChange={handleInputChange}
      />
      <Select
        label='State'
        value={location.state || ''}
        name='state'
        data={[{ value: '', label: '-- Select --' }, ...STATES]}
        onChange={(value) => handleSelectChange('state', value)}
      />
      <TextInput
        label='Postal Code'
        placeholder='12345'
        name='zipCode'
        maxLength={10}
        value={location.zipCode || ''}
        onChange={handleInputChange}
      />
    </Stack>
  )
}

export default ManualAddressForm
